import React from 'react';
import styled from 'styled-components/macro';

const DisplayPending = () => {

  return (
    <PendingContainer>
      <PendingBordered>
        <Message>The current submission is still in analysis</Message>
        <PostNote>... this page will auto-refresh every 10s until it is completed ...</PostNote>
      </PendingBordered>
    </PendingContainer>
  );
};

export default DisplayPending;

const PendingContainer = styled.div`
  display: flex;
  height: 60px;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`;

const PendingBordered = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80%;
  min-width: max-content;
  background-color: ${(p) => p.theme.palette.backgroundPrimary };
  border-radius: 15px;
  border: solid 1px ${(p) => p.theme.palette.accentPrimary };
`;

const Message = styled.div<{ justifyContent?: string }>`
  display: flex;
  font-size: 18px;
  color: ${(p) => p.theme.palette.accentPrimary };
`;

const PostNote = styled(Message)`
  font-size: 12px;
  font-style: italic;
  color: ${(p) => p.theme.palette.textSecondary };
`;

